import Vue from "vue";
import Vuex from "vuex";
import template from "./modules/template";
import auth from "./modules/auth";
import user from "./modules/user";
import product from "./modules/product";
import client from "./modules/client";
import analytics from "./modules/analytics";
import transaction from "./modules/transaction";
import notification from "./modules/notification";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    template,
    user,
    auth,
    product,
    client,
    analytics,
    transaction,
    notification,
  },
});
